/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const FontAwesomeFlagIconConfig = {
  name: 'FontAwesomeFlagIcon',
  height: 512,
  width: 448,
  svgPath: 'M444.373 359.424c0 7.168-6.144 10.24-13.312 13.312-28.672 12.288-59.392 23.552-92.16 23.552-46.08 0-67.584-28.672-122.88-28.672-39.936 0-81.92 14.336-115.712 29.696-2.048 1.024-4.096 1.024-6.144 2.048v77.824c0 21.405-16.122 34.816-33.792 34.816-19.456 0-34.816-15.36-34.816-34.816V102.4C12.245 92.16 3.029 75.776 3.029 57.344 3.029 25.6 28.629 0 60.373 0s57.344 25.6 57.344 57.344c0 18.432-8.192 34.816-22.528 45.056v31.744c4.124-1.374 58.768-28.672 114.688-28.672 65.27 0 97.676 27.648 126.976 27.648 38.912 0 81.92-27.648 92.16-27.648 8.192 0 15.36 6.144 15.36 13.312v240.64z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(FontAwesomeFlagIconConfig);